module.exports = __webpack_public_path__ + "static/media/Stellar King Actuator Bed Base - 180x200 cm_.4bf71dca.png";